import AlertsContext from "common/providers/alerts";
import useRouter from "common/hooks/use-router";
import useItem from "common/hooks/useItem";
import { useCallback, useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";
import useAnimal from "common/hooks/useAnimal";
import { ImportItemStatus } from "types/Import";
import fetchJSON from "common/utils/fetchJSON";
import ObservationGridForm from "pages/ObservationGrids/ObservationGridForm";

function ImportDetailObservationGrid() {
  const { t } = useTranslation();
  const router = useRouter();
  const { setAlert } = useContext(AlertsContext);
  const { refreshAnimals } = useAnimal();

  const id = router.query.id as string;

  const {
    item: importItem,
    error: importError,
    isFetching: importIsFetching,
  }: any = useItem("imports", id, {
    listenToEvents: [
      "import_file_imported",
      "import_file_new_data",
      "import_file_imported_with_error",
      "import_file_updated",
    ],
  });

  const { saveItem, error, isFetching }: any = useItem("observation-grids", "");

  const back = useCallback(() => {
    if (!error || !importError) {
      setAlert(t("common.saved"), "success");
      router.navigate(-1);
    }
  }, [error, importError, setAlert, t, router]);

  // Ici on vient mettre à jour le status de l'import
  const updateImportStatus = useCallback(async () => {
    try {
      const updatedData = importItem?.parsedContent?.data?.map((data: any) => ({
        ...data,
        status: ImportItemStatus.IMPORTED,
      }));

      await fetchJSON({
        url: `imports/update-status`,
        method: "PUT",
        payload: {
          data: {
            ...importItem,
            parsedContent: {
              ...importItem?.parsedContent,
              data: updatedData,
            },
          },
        },
      });
    } catch (err) {
      console.error("Update import status error:", err);
    }
  }, [importItem]);

  const onSubmit = useCallback(
    async (observationGridData: any) => {
      const newObservationGrid = { ...observationGridData };

      try {
        await saveItem(newObservationGrid);
        updateImportStatus();
      } catch (e: any) {
        return e;
      }
      refreshAnimals();
      back();
      return true;
    },
    [refreshAnimals, back, saveItem, updateImportStatus]
  );

  const formatedImportedValues = useMemo(
    () => ({
      name: importItem?.fileName,
      park: importItem?.park,
      sections: importItem?.parsedContent?.data,
    }),
    [importItem]
  );

  return isFetching || importIsFetching || (id && !importItem) ? null : (
    <ObservationGridForm
      onSubmit={onSubmit}
      observationGrid={formatedImportedValues}
      isFromImport
    />
  );
}

export default ImportDetailObservationGrid;
